export default __webpack_public_path__ + "static/media/gallery-7.ef6d936e.jpg";